import React from "react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { Toaster } from "sonner";
import { Provider } from "react-redux";
import { store } from "./store/store.ts";
import { SidebarProvider } from "./uiComponents/components/ui/sidebar.tsx";
import { SideBar } from "./components/SIdebar/SideBar.tsx";
import { BrowserRouter } from "react-router-dom";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <SidebarProvider>
        <BrowserRouter>
          <div className="flex h-screen w-screen overflow-hidden">
            <SideBar />
            <div className="flex flex-1 flex-col overflow-hidden transition-all duration-200 ease-in-out md:ml-[--sidebar-width-icon] md:data-[state=expanded]:ml-[--sidebar-width]">
              <Toaster richColors position="top-right" />
              <App />
            </div>
          </div>
        </BrowserRouter>
      </SidebarProvider>
    </Provider>
  </StrictMode>,
);
